import axios from "axios";
import { API_TIMEOUT } from "../constants";
import { API_REQUEST_TYPES } from "../enums";
import { showNotification } from "../store/modules/UI";
import { getResErrorMsg } from "./utils";
import { userLogout } from "../api/auth";

const { REACT_APP_API_URL } = process.env;

const defaultConfig: any = {
  validateUser: true,
  notifyError: true,
  notifySuccess: true,
  successMessage: "",
};

function getHeaders(config) {
  return {
    timeout: API_TIMEOUT,
    headers: {
      ...(config?.validateUser && { Authorization: localStorage.token }),
    },
  };
}

const delay = () => new Promise((resolve) => setTimeout(resolve, 0));

function handleServerError(err, config) {
  return async function (dispatch) {
    let { message, responseStatus }: any = getResErrorMsg(err);

    config.notifyError &&
      dispatch(
        showNotification({
          message,
          type: "error",
        })
      );

    if (responseStatus === 401) {
      dispatch(userLogout());
    }

    config.failFn && dispatch(config.failFn(message));

    return {
      success: false,
      message,
      ...err?.response?.data,
    };
  };
}

function handleSuccessResponse(res, config) {
  return async function (dispatch) {
    const message = res.data.message || config.successMessage;
    config.notifySuccess &&
      message &&
      dispatch(
        showNotification({
          message,
          type: "success",
        })
      );
    return res.data;
  };
}

export function resetApi({ type, url, payload, config = defaultConfig }: any) {
  return async function (dispatch) {
    config = {
      ...defaultConfig,
      ...config,
    };

    config.loadingFn && dispatch(config.loadingFn(true));

    const endpoint = config.externalUrl ? url : REACT_APP_API_URL + url;

    switch (type) {
      case API_REQUEST_TYPES.GET:
        return axios
          .get(endpoint, {
            ...getHeaders(config),
          })
          .then((res) => delay().then(() => res))
          .then((res) => dispatch(handleSuccessResponse(res, config)))
          .catch((err) => dispatch(handleServerError(err, config)))
          .finally(() => {
            config.loadingFn && dispatch(config.loadingFn(false));
          });
      case API_REQUEST_TYPES.POST:
        return axios
          .post(endpoint, payload, {
            ...getHeaders(config),
          })
          .then((res) => delay().then(() => res))
          .then((res) => dispatch(handleSuccessResponse(res, config)))
          .catch((err) => dispatch(handleServerError(err, config)))
          .finally(() => {
            config.loadingFn && dispatch(config.loadingFn(false));
          });

      case API_REQUEST_TYPES.PUT:
        return axios
          .put(endpoint, payload, {
            ...getHeaders(config),
          })
          .then((res) => delay().then(() => res))
          .then((res) => dispatch(handleSuccessResponse(res, config)))
          .catch((err) => dispatch(handleServerError(err, config)))
          .finally(() => {
            config.loadingFn && dispatch(config.loadingFn(false));
          });

      case API_REQUEST_TYPES.PATCH:
        return axios
          .patch(endpoint, payload, {
            ...getHeaders(config),
          })
          .then((res) => delay().then(() => res))
          .then((res) => dispatch(handleSuccessResponse(res, config)))
          .catch((err) => dispatch(handleServerError(err, config)))
          .finally(() => {
            config.loadingFn && dispatch(config.loadingFn(false));
          });

      case API_REQUEST_TYPES.DELETE:
        return axios
          .delete(endpoint, {
            ...getHeaders(config),
            data: payload,
          })
          .then((res) => delay().then(() => res))
          .then((res) => dispatch(handleSuccessResponse(res, config)))
          .catch((err) => dispatch(handleServerError(err, config)))
          .finally(() => {
            config.loadingFn && dispatch(config.loadingFn(false));
          });

      default:
        return axios
          .get(endpoint, {
            ...getHeaders(config),
          })
          .then((res) => delay().then(() => res))
          .then((res) => dispatch(handleSuccessResponse(res, config)))
          .catch((err) => dispatch(handleServerError(err, config)))
          .finally(() => {
            config.loadingFn && dispatch(config.loadingFn(false));
          });
    }
  };
}
